module.exports = __webpack_public_path__ + "static/CityGuild-cbeb694585f0f11e21bd13ef8fe46fcd.png";